export default __webpack_public_path__ + "static/media/netflix.10fa1089.png";